module.exports = __webpack_public_path__ + "img/stone-path-o.b4acf843.png";